import React from "react";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const ListOneAgreementMaster = createSlice({
  name: "ListOneAgreementMaster",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFirst: true,
    data: [],
  },
  reducers: {
    list_one_agreement_master: (state, action?) => {
      state.isLoading = true;
    },
    success_api_call_list_one_agreement_master: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.isFirst = true;
    },
    failure_api_call_list_one_agreement_master: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
    },
    agreement_master_list_one_is_first: (state, action) => {
      state.isFirst = false;
    },
    clear_list_one_agreement_master: (state) => {
      state.data = [];
    },
  },
});
export default ListOneAgreementMaster.reducer;
export const {
  list_one_agreement_master,
  success_api_call_list_one_agreement_master,
  failure_api_call_list_one_agreement_master,
  agreement_master_list_one_is_first,
  clear_list_one_agreement_master,
} = ListOneAgreementMaster.actions;
